import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AgmCoreModule } from '@agm/core';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule} from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FirebaseService } from './services/firebase.service';
import { environment } from '../environments/environment';

import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import {MatTableModule} from '@angular/material/table';
import { MatPaginatorModule } from "@angular/material/paginator";
import {MatSelectModule} from '@angular/material/select';
import { MatCardModule } from "@angular/material/card";
import {MatGridListModule} from '@angular/material/grid-list';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { HomeComponent } from './home/home.component';
import { MatMenuModule } from '@angular/material/menu';
import { BroadbandComponent } from './home/broadband/broadband.component';
import { FiberComponent } from './home/fiber/fiber.component';
import { AdminComponent } from './admin/admin.component';
import { AdminbackendComponent } from './admin/adminbackend/adminbackend.component';
import { CreateplanComponent } from './admin/adminbackend/createplan/createplan.component';
import { EditplanComponent } from './admin/adminbackend/editplan/editplan.component';
import { AllplansComponent } from './admin/adminbackend/allplans/allplans.component';
import { ManageusersComponent } from './admin/adminbackend/manageusers/manageusers.component';
import { ManageordersComponent } from './admin/adminbackend/manageorders/manageorders.component';
import { PlansComponent } from './plans/plans.component';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SigninComponent } from './user/signin/signin.component';
import { SignupComponent } from './user/signup/signup.component';
import { PwresetComponent } from './user/pwreset/pwreset.component';
import { VerifyemailComponent } from './user/verifyemail/verifyemail.component';
import { AboutComponent } from './home/about/about.component';
import { ContactComponent } from './about/contact/contact.component';
import { FeedbackComponent } from './about/feedback/feedback.component';
import { OurServicesComponent } from './about/our-services/our-services.component';
import { SelectedplanComponent } from './home/selectedplan/selectedplan.component';
import { OrdersComponent } from './home/orders/orders.component';
import { TermsnconditionsComponent } from './termsnconditions/termsnconditions.component';
import { WindowRef } from './services/windowRef.service';
import { PpolicyComponent } from './termsnconditions/ppolicy/ppolicy.component';
import { UpolicyComponent } from './termsnconditions/upolicy/upolicy.component';
import { MessagesComponent } from './admin/adminbackend/messages/messages.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BroadbandComponent,
    FiberComponent,
    AdminComponent,
    AdminbackendComponent,
    CreateplanComponent,
    EditplanComponent,
    AllplansComponent,
    ManageusersComponent,
    ManageordersComponent,
    PlansComponent,
    SigninComponent,
    SignupComponent,
    PwresetComponent,
    VerifyemailComponent,
    AboutComponent,
    ContactComponent,
    FeedbackComponent,
    OurServicesComponent,
    SelectedplanComponent,
    OrdersComponent,
    TermsnconditionsComponent,
    PpolicyComponent,
    UpolicyComponent,
    MessagesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    MatCardModule,
    MatGridListModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB24q_UMHjlEeoarHBYWzWoEaAP1BcXxVo'
    }),
    NgbModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    FormsModule, ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule
  ],
  providers: [FirebaseService, WindowRef,
  {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
